import React from "react";
import { Image, Text, TouchableOpacity, View } from "react-native";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";

const SearchedGame = ({ gameData }) => {
  const deviceSize = useDeviceSize();

  return (
    <View
      style={{
        marginLeft:
          deviceSize === DEVICE_SIZES.SM ||
          deviceSize === DEVICE_SIZES.XS ||
          deviceSize === DEVICE_SIZES.MD ||
          deviceSize === DEVICE_SIZES.LG
            ? 0
            : 35,
      }}
    >
      <Text
        style={[
          deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
            ? AppFontStyle.BOLD_ANYBODY_20
            : AppFontStyle.BOLD_ANYBODY_24,
          { color: AppColors.white, marginBottom: 20, textAlign: "center" },
        ]}
      >
        {gameData?.gameName}
      </Text>

      <TouchableOpacity onPress={() => {}} style={{ alignItems: "center" }}>
        <Image
          source={gameData?.image}
          style={{
            width: 196,
            height: 228,
            borderRadius: 20,
            resizeMode: "contain",
            borderWidth: 3,
            borderColor: AppColors.green_4CD964,
          }}
        />
      </TouchableOpacity>
    </View>
  );
};

export default SearchedGame;
